export { default as Img200 } from './processed/200/alizee.jpg';
export { default as Img400 } from './processed/400/alizee.jpg';
export { default as Img600 } from './processed/600/alizee.jpg';
export { default as Imgthumb } from './processed/thumb/alizee.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/alizee.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/alizee.jpg';
export const ImgData = { width: 1024, height: 768, ratio: 0.75, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      32,
      84,
      214
    ],
    "_population": 494,
    "_hsl": [
      0.6190476190476191,
      0.7398373983739838,
      0.4823529411764706
    ]
  },
  "LightVibrant": {
    "_rgb": [
      242,
      158,
      115
    ],
    "_population": 478,
    "_hsl": [
      0.056430446194225735,
      0.830065359477124,
      0.7
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      98,
      63,
      40
    ],
    "_population": 1888,
    "_hsl": [
      0.06609195402298851,
      0.42028985507246375,
      0.2705882352941177
    ]
  },
  "Muted": {
    "_rgb": [
      152,
      136,
      111
    ],
    "_population": 631,
    "_hsl": [
      0.1016260162601626,
      0.1659919028340081,
      0.5156862745098039
    ]
  },
  "LightMuted": {
    "_rgb": [
      188,
      203,
      213
    ],
    "_population": 1145,
    "_hsl": [
      0.5666666666666668,
      0.22935779816513768,
      0.7862745098039217
    ]
  },
  "DarkMuted": {
    "_rgb": [
      63,
      46,
      33
    ],
    "_population": 1060,
    "_hsl": [
      0.0722222222222222,
      0.3125,
      0.18823529411764706
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/alizee.js